module.exports = __webpack_public_path__ + "static/media/warning2.e2ac1e7a.png";